import { useApolloClient } from '@apollo/client'
import GET_USER from './queries/getUser.graphql'
import INIT_STUDENT_PASSWORD from './mutations/initStudentPassword.graphql'

export const useData = () => {
  const client = useApolloClient()
  
  const getUser = async (username: any) => {
    const { data } = await client.query({
      query: GET_USER,
      variables: {
        input: { username }
      },
      fetchPolicy: 'network-only'
    })
    return data
  }

  const initStudentPassword = async (user: string, password: string) => {
    const { data } = await client.mutate({
      mutation: INIT_STUDENT_PASSWORD,
      variables: {
        user,
        password
      }
    })
    return data
  }


  return {
    getUser,
    initStudentPassword,
  }
}